import * as Sentry from '@sentry/vue'
import { jwtDecode } from 'jwt-decode'

export const UNKNOWN = 'unknown'

function getCookie(name) {
  const value = '; ' + document.cookie
  const parts = value.split('; ' + name + '=')
  if (parts.length === 2) return parts.pop().split(';').shift()
  return undefined
}

// Resolve user/company identity from the auth JWT cookie, falling back to
// 'unknown' placeholders when the session or token is unavailable.
export function resolveUserContext() {
  try {
    const token = getCookie('UniqApi.Token')
    if (token) {
      const decoded = jwtDecode(token)
      return {
        userId: decoded.userid || UNKNOWN,
        companyId: decoded.companyid || UNKNOWN
      }
    }
  } catch (e) {
    // ignore – fall through to placeholders
  }
  return { userId: UNKNOWN, companyId: UNKNOWN }
}

export function setSentryUserContext() {
  const { userId, companyId } = resolveUserContext()
  Sentry.setUser({ id: userId, companyId })
}

export function clearSentryUserContext() {
  Sentry.setUser(null)
}

export function enrichSentryEvent(event) {
  const { userId, companyId } = resolveUserContext()

  event.user = {
    ...(event.user || {}),
    id: (event.user && event.user.id) || userId,
    companyId: (event.user && event.user.companyId) || companyId
  }

  event.tags = { ...(event.tags || {}) }
  if (!event.tags.userId) event.tags.userId = userId
  if (!event.tags.companyId) event.tags.companyId = companyId

  if (userId === UNKNOWN || companyId === UNKNOWN) {
    // eslint-disable-next-line no-console
    console.warn('[Sentry] Reporting error with missing user context', { userId, companyId })
  }

  return event
}
